import { useLocalStorage as useLS } from 'react-use';
export default function useLocalStorage(key, initialValue, options) {
  return useLS(key, initialValue, options);
}